const TIMELINE = [
  {
    step: "01",
    title: "Sourcing",
    body: "We taste hundreds of green coffees each season, then travel to the farms behind the ones that move us. Long conversations, longer flights.",
  },
  {
    step: "02",
    title: "Green Storage",
    body: "Unroasted beans rest in our climate-kept vault, waiting for their turn. Humidity, temperature, and time all under close watch.",
  },
  {
    step: "03",
    title: "Profile",
    body: "Each new lot is sample-roasted three times over three days. We chart curves, cup blind, and only then commit a profile to production.",
  },
  {
    step: "04",
    title: "First Light Roast",
    body: "The drum turns before dawn. Small batches — never more than 12kg at a time — let us listen for the first and second crack.",
  },
  {
    step: "05",
    title: "Rest",
    body: "Fresh-roasted coffee needs a quiet 48 to 72 hours to bloom. We degas, seal, and date every bag by hand.",
  },
  {
    step: "06",
    title: "Your Cup",
    body: "By the time it reaches your kettle, the coffee has traveled with intention every step of the way. All that&apos;s left is the pour.",
  },
];

export default function About() {
  return (
    <section id="about" className="w-full bg-primary-950 text-background-50 py-24 md:py-36 px-6 md:px-10 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 mb-20">
          <div className="lg:col-span-5 reveal">
            <span className="text-xs tracking-[0.35em] uppercase text-accent-400">About Meridian</span>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl mt-4 leading-tight">
              The long, quiet <em className="text-accent-300">art</em> of a good cup.
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-6 reveal">
            <p className="text-background-200 text-lg leading-relaxed mb-6">
              Meridian is a family of six roasters, two bakers, and a rescue dog named Biscuit. We share a workshop
              on SE Division — half warehouse, half living room — where the smell of caramelizing sugars starts before the
              streetlights go dark.
            </p>
            <p className="text-background-300 leading-relaxed">
              We&apos;re not chasing trends or chasing scale. We&apos;re trying, batch by batch, to make coffee that tastes
              honest. That&apos;s the whole ambition.
            </p>
          </div>
        </div>

        <div className="reveal">
          <div className="flex items-baseline justify-between mb-12 flex-wrap gap-4">
            <h3 className="font-heading text-3xl md:text-4xl">
              From green bean, <em className="text-accent-300">to your cup.</em>
            </h3>
            <span className="text-sm text-background-300 tracking-widest uppercase">Our Roasting Process</span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {TIMELINE.map((t, idx) => (
              <div
                key={t.step}
                className="relative border border-primary-800 rounded-lg p-8 bg-primary-900/40 hover:bg-primary-900 transition-colors reveal"
                style={{ transitionDelay: `${idx * 60}ms` }}
              >
                <div className="flex items-baseline gap-4 mb-4">
                  <span className="font-heading text-5xl text-accent-400">{t.step}</span>
                  <span className="h-px flex-1 bg-primary-700 mb-3"></span>
                </div>
                <h4 className="font-heading text-xl mb-3">{t.title}</h4>
                <p className="text-background-300 text-sm leading-relaxed">{t.body}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}